import { Modal } from 'antd';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import { ICustomerUI } from 'types/customer';
import inCommingCallIcon from './incomming.svg';
import aptSignal from 'AppointmentBox/signal';
import { maskPhone } from 'utils/formatPhone';
type Props = {};
type ICallerIdRef = {
  open: (customer: ICustomerUI) => void;
};

export const callerIdRef = React.createRef<ICallerIdRef>();
const CallerIdUI = forwardRef<ICallerIdRef, Props>((props, ref) => {
  const [open, setOpen] = useState(false);
  const [customer, setCustomer] = useState<ICustomerUI | null>(null);
  const onClose = () => setOpen(false);

  const onBook = () => {
    onClose();
    if (!customer) return;
    aptSignal.openWithCustomer(customer);
  };

  useImperativeHandle(ref, () => ({
    open: (_customer: ICustomerUI) => {
      setOpen(true);
      setCustomer(_customer);
    },
  }));

  return (
    <Modal centered open={open} footer={<></>} closable={false} closeIcon={null} width={540} destroyOnClose={false}>
      <Container>
        <Body>
          <img src={inCommingCallIcon} alt="inCommingCallIcon" className='icon' />
          <div className='calling-container'>
            <span className='label'>Incoming call...</span>
            <div className='cus-phone'>
              <span className='phone-label'>{customer?.name || 'Unknown name'}</span>
              <span className='phone-number'>{customer?.phone ? maskPhone(customer.phone) : '--'}</span>
            </div>
          </div>
        </Body>
        <Footer>
          <button onClick={onClose} type='button' className="btn"><span>CLOSE</span></button>
          <button onClick={onBook} type='button' className="btn btn-submit"><span>BOOK</span></button>
        </Footer>
      </Container>
    </Modal>
  );
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  overflow: hidden;
  background: #F8F9FE;
`;

const Body = styled.div`
  display: flex;
  padding: 32px 24px 16px 24px;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  background: #fff;
  img.icon {
    width: 124px;
    height: 124px;
    aspect-ratio: 1/1;
  }

  .calling-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 16px;
    flex: 1 0 0;
    .label {
      color: #00A140;
      font-family: Poppins;
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    .cus-phone {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
      align-self: stretch;
      span {
        color: #1D2129;
        font-family: Poppins;
        font-size: 36px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        &.phone-label {
          font-size: 32px;
          font-weight: 500;
        }
      }
    }
  }
`;

const Footer = styled.div`
  display: flex;
  padding: 24px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  button.btn {
    display: flex;
    padding: 16px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    border-radius: 4px;
    background: #CCD4DC;
    box-shadow: 0 4px 8px -3px rgba(45, 35, 66, 0.30);

    &:active {
      opacity: 0.6;
    }

    span {
      color: #1D2129;
      text-align: center;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    &.btn-submit {
      background: #00A140;
      span {
        color: #ffffff;
      }
    }
  }
`;

export { CallerIdUI };

const CallerId = {
  open: (customer: ICustomerUI) => callerIdRef.current?.open(customer),
};

export default CallerId;